/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import gql from "graphql-tag";

export const UPDATE_ASSET_DETAIL = gql`
mutation EditAsset($data: EditAssetInput!, $tokenId: String, $tokenGroup: String) {
  editAsset(data: $data, tokenId: $tokenId, tokenGroup: $tokenGroup)
}`

export const UPDATE_DUPLICATE_ASSET = gql`
mutation Mutation($input: ChangePrimaryAssetInput!) {
  changePrimaryAsset(input: $input)
}
`